import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_KICKSTART_TOGGLE = defineFcm('starfish_petition_kickstart_toggle')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
